// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_3eDXD){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3Ctae .dualColumn_32FPY{display:flex;align-content:space-between}.nsAddressForm_3Ctae .dualColumn_32FPY .firstCol_2xnEy{margin-right:20px}.nsAddressForm_3Ctae .dualColumn_32FPY .region_35Zul{width:70px}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_3eDXD",
	"nsAddressForm": "nsAddressForm_3Ctae",
	"dualColumn": "dualColumn_32FPY",
	"firstCol": "firstCol_2xnEy",
	"region": "region_35Zul"
};
module.exports = exports;
